var twig = require("twig").twig,
    tokens = [{"type":"raw","value":"<input (input) type=\"text\">"}],
    template = twig({"id":"$resolved:77319831d4f7eac1daa99366f6ff51b313737f79c557c21eacb2a4f29f9b9248ca74a7dc2f092eaebd654656e91d7777fca266667173862236543647ea3b8efa:magic-input-string.twig","data":[{"type":"raw","value":"<input (input) type=\"text\">"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;